import { fetchAuthSession } from "aws-amplify/auth";
import { ClaimUser } from "../models/authorize.model";
import { Company } from "../models/company.model";
import api from "../lib/api";
import { SurveyEvent } from "../models/survey.event.model";

export async function initialLoggedUser(): Promise<ClaimUser | undefined> {
  const a = await fetchAuthSession();
  return convertToClaimUser(a.tokens?.idToken?.payload);
}

export async function getSelf(): Promise<{
  company: Company;
  allowedHierarchies: string[];
  surveyEvents: SurveyEvent[];
}> {
  return await api<{
    company: Company;
    allowedHierarchies: string[];
    surveyEvents: SurveyEvent[];
  }>({
    url: "company-self",
    method: "GET",
  });
}

export function convertToClaimUser(payload: any) {
  if (!payload) {
    return;
  }
  const user: ClaimUser = {
    username: payload["cognito:username"],
    name: payload["name"],
    picture: payload["picture"],
    role: (payload["cognito:groups"] || [])[0],
    email: payload["email"],
    emailVerified: payload["email_verified"],
    companyId: payload["locale"],
  };
  return user;
}
